import { Turbo } from "@hotwired/turbo-rails";
import {
  dispatchSettingsInvalidation,
  dispatchSettingsInvalidationHeader,
} from "../utils/settings_invalidation";

Turbo.StreamActions.invalidate_settings_tabs = function invalidateSettingsTabs() {
  const encodedTabs = this.getAttribute("tabs");
  if (!encodedTabs) {
    return;
  }

  try {
    dispatchSettingsInvalidation(JSON.parse(encodedTabs));
  } catch (_error) {
    // Ignore malformed server data so an unrelated stream action can continue.
  }
};

document.addEventListener("turbo:before-fetch-response", (event) => {
  dispatchSettingsInvalidationHeader(event.detail.fetchResponse.response);
});
